import { assetsCdnUrl } from '~/constants/environment';
import type { BodyStyle } from '~/contracts/common';

const homeFeedBodyStyles: BodyStyle[] = [
  {
    alt: 'SUVs',
    bodyStyleInCvnaid: 'Suv',
    image: `${assetsCdnUrl}/home-assets/nba/suv.png`,
    link: '/cars/suv',
    mobileImage: `${assetsCdnUrl}/home-assets/nba/suv.png?width=80`,
    tabletImage: `${assetsCdnUrl}/home-assets/nba/suv.png?width=150`
  },
  {
    alt: 'Sedans',
    bodyStyleInCvnaid: 'Sedan',
    image: `${assetsCdnUrl}/home-assets/nba/sedan.png`,
    link: '/cars/sedan',
    mobileImage: `${assetsCdnUrl}/home-assets/nba/sedan.png?width=80`,
    tabletImage: `${assetsCdnUrl}/home-assets/nba/sedan.png?width=150`
  },
  {
    alt: 'Trucks',
    bodyStyleInCvnaid: 'Pickup',
    image: `${assetsCdnUrl}/home-assets/nba/truck.png`,
    link: '/cars/truck',
    mobileImage: `${assetsCdnUrl}/home-assets/nba/truck.png?width=80`,
    tabletImage: `${assetsCdnUrl}/home-assets/nba/truck.png?width=150`
  },
  {
    alt: 'EVs',
    fuelTypeInCvnaid: 'Electric',
    image: `${assetsCdnUrl}/home-assets/nba/electric.png`,
    link: '/cars/electric',
    mobileImage: `${assetsCdnUrl}/home-assets/nba/electric.png?width=80`,
    tabletImage: `${assetsCdnUrl}/home-assets/nba/electric.png?width=150`
  },
  {
    alt: 'Hybrids',
    fuelTypeInCvnaid: 'Hybrid',
    image: `${assetsCdnUrl}/home-assets/nba/hybrid.png`,
    link: '/cars/hybrid',
    mobileImage: `${assetsCdnUrl}/home-assets/nba/hybrid.png?width=80`,
    tabletImage: `${assetsCdnUrl}/home-assets/nba/hybrid.png?width=150`
  },
  {
    alt: 'Coupes',
    bodyStyleInCvnaid: 'Coupe',
    image: `${assetsCdnUrl}/home-assets/nba/coupe.png`,
    link: '/cars/coupe',
    mobileImage: `${assetsCdnUrl}/home-assets/nba/coupe.png?width=80`,
    tabletImage: `${assetsCdnUrl}/home-assets/nba/coupe.png?width=150`
  },
  {
    alt: 'Hatchbacks',
    bodyStyleInCvnaid: 'Hatchback',
    image: `${assetsCdnUrl}/home-assets/nba/hatchback.png`,
    link: '/cars/hatchback',
    mobileImage: `${assetsCdnUrl}/home-assets/nba/hatchback.png?width=80`,
    tabletImage: `${assetsCdnUrl}/home-assets/nba/hatchback.png?width=150`
  },
  {
    alt: 'Wagons',
    bodyStyleInCvnaid: 'Wagon',
    image: `${assetsCdnUrl}/home-assets/nba/wagon.png`,
    link: '/cars/wagon',
    mobileImage: `${assetsCdnUrl}/home-assets/nba/wagon.png?width=80`,
    tabletImage: `${assetsCdnUrl}/home-assets/nba/wagon.png?width=150`
  },
  {
    alt: 'Convertibles',
    bodyStyleInCvnaid: 'Convertible',
    image: `${assetsCdnUrl}/home-assets/nba/convertible.png`,
    link: '/cars/convertible',
    mobileImage: `${assetsCdnUrl}/home-assets/nba/convertible.png?width=80`,
    tabletImage: `${assetsCdnUrl}/home-assets/nba/convertible.png?width=150`
  },
  {
    alt: 'Minivans',
    bodyStyleInCvnaid: 'MiniVan',
    image: `${assetsCdnUrl}/home-assets/nba/minivan.png`,
    link: '/cars/minivan',
    mobileImage: `${assetsCdnUrl}/home-assets/nba/minivan.png?width=80`,
    tabletImage: `${assetsCdnUrl}/home-assets/nba/minivan.png?width=150`
  },
  {
    alt: 'Plug-in Hybrids',
    fuelTypeInCvnaid: 'Plug-In Hybrid',
    image: `${assetsCdnUrl}/home-assets/nba/plug-in-hybrid.png`,
    link: '/cars/plugin-hybrid',
    mobileImage: `${assetsCdnUrl}/home-assets/nba/plug-in-hybrid.png?width=80`,
    tabletImage: `${assetsCdnUrl}/home-assets/nba/plug-in-hybrid.png?width=150`
  }
];

export default homeFeedBodyStyles;
